<div class="gw-space-y-4">
  <div>
    <h3 class="gw-text-base gw-font-semibold gw-text-text-primary gw-m-0">
      {{ 'features.dashboard.cards.latestTransactions.title' | translate }}
    </h3>
    <p class="gw-text-sm gw-text-text-secondary gw-mt-2 gw-mb-0">
      {{
        'features.dashboard.cards.latestTransactions.description' | translate
      }}
    </p>
  </div>

  <div *ngIf="isLoading" class="gw-flex gw-justify-center gw-py-8">
    <gatewee-element-spinner></gatewee-element-spinner>
  </div>

  <div
    *ngIf="!isLoading && hasTransactions"
    class="gw-overflow-x-auto gw-rounded-xl gw-border gw-border-border-normal gw-bg-background-elevation-1 gw-overflow-hidden"
  >
    <table tuiTable size="s" class="gw-w-full gw-table-size-s">
      <thead>
        <tr>
          <th tuiTh class="gw-w-14 gw-text-center">
            <div [tuiCell]="'s'" class="gw-justify-center">
              <span tuiTitle class="gw-text-text-secondary gw-text-xs">
                {{
                  'features.dashboard.cards.latestTransactions.table.direction'
                    | translate
                }}
              </span>
            </div>
          </th>
          <th tuiTh>
            <div [tuiCell]="'s'">
              <span tuiTitle class="gw-text-text-secondary gw-text-xs">
                {{
                  'features.dashboard.cards.latestTransactions.table.counterparty'
                    | translate
                }}
              </span>
            </div>
          </th>
          <th tuiTh>
            <div [tuiCell]="'s'">
              <span tuiTitle class="gw-text-text-secondary gw-text-xs">
                {{ 'common.table.columns.date' | translate }}
              </span>
            </div>
          </th>
          <th tuiTh class="gw-text-right">
            <div [tuiCell]="'s'" class="gw-justify-end">
              <span tuiTitle class="gw-text-text-secondary gw-text-xs">
                {{ 'common.table.columns.amount' | translate }}
              </span>
            </div>
          </th>
          <th tuiTh class="gw-text-right">
            <div [tuiCell]="'s'" class="gw-justify-end">
              <span tuiTitle class="gw-text-text-secondary gw-text-xs">
                {{ 'common.table.columns.type' | translate }}
              </span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody tuiTbody>
        <tr *ngFor="let transaction of transactions?.records">
          <td tuiTd class="gw-w-14 gw-text-center">
            <div [tuiCell]="'s'" class="gw-items-center gw-justify-center">
              <gatewee-icon
                *ngIf="(transaction.type | transactionType : true) === 'IN'"
                icon="@tui.arrow-down-circle"
                size="22px"
                class="gw-text-status-positive"
              ></gatewee-icon>
              <gatewee-icon
                *ngIf="(transaction.type | transactionType : true) === 'OUT'"
                icon="@tui.arrow-up-circle"
                size="22px"
                class="gw-text-status-negative"
              ></gatewee-icon>
            </div>
          </td>
          <td tuiTd>
            <div [tuiCell]="'s'">
              <ng-container *ngIf="transaction.invoice; else recipientOnlyTpl">
                <a
                  class="gw-text-sm gw-font-medium gw-text-text-primary hover:gw-underline gw-block"
                  [routerLink]="['/panel/transactions/view', transaction.id]"
                >
                  {{
                    transaction?.invoice?.client?.name?.toUpperCase() ?? ''
                      | reduceName
                  }}
                </a>
                <span
                  class="gw-text-xs gw-text-text-secondary gw-block gw-mt-0.5"
                >
                  {{
                    transaction?.invoice?.client?.document ?? ''
                      | document : true
                  }}
                </span>
              </ng-container>
              <ng-template #recipientOnlyTpl>
                <a
                  class="gw-text-sm gw-font-medium gw-text-text-primary hover:gw-underline gw-block"
                  [routerLink]="['/panel/transactions/view', transaction.id]"
                >
                  {{
                    transaction?.recipient?.name?.toUpperCase() ?? ''
                      | reduceName
                  }}
                </a>
                <span
                  class="gw-text-xs gw-text-text-secondary gw-block gw-mt-0.5"
                >
                  {{ transaction?.recipient?.document ?? '' | document : true }}
                </span>
              </ng-template>
            </div>
          </td>
          <td tuiTd>
            <div [tuiCell]="'s'">
              <span class="gw-text-sm gw-text-text-primary gw-font-medium">
                {{ transaction.createdAt | date : 'dd/MM/yyyy' }}
              </span>
              <span class="gw-text-xs gw-text-text-secondary gw-block">
                {{ transaction.createdAt | date : 'HH:mm' }}
              </span>
            </div>
          </td>
          <td tuiTd class="gw-text-right">
            <div [tuiCell]="'s'" class="gw-justify-end">
              <span
                class="gw-text-sm gw-font-semibold gw-text-text-primary gw-tabular-nums"
              >
                {{
                  transaction.amount
                    | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
                }}
              </span>
            </div>
          </td>
          <td tuiTd class="gw-text-right">
            <div [tuiCell]="'s'" class="gw-justify-end">
              <span
                class="gw-text-sm gw-font-medium gw-block"
                [class.gw-text-status-positive]="transaction.type === 'income'"
                [class.gw-text-status-warning]="transaction.type !== 'income'"
              >
                {{ transaction.type | transactionType }}
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div
    *ngIf="!isLoading && !hasTransactions"
    class="gw-text-center gw-py-10 gw-rounded-xl gw-border gw-border-border-dashed gw-border-border-normal gw-bg-background-elevation-1"
  >
    <p class="gw-text-sm gw-text-text-secondary gw-m-0">
      {{ 'common.dataNotFound' | translate }}
    </p>
  </div>
</div>
